/**
 * Shared nav menu item styling (matches feagi-desktop Launcher menus).
 */
export const NAV_MENU_ITEM_ICON_SX = { mr: 1 };
